import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/pager/pager.j.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import { GridPagerWrapper } from "../../component_wrapper/grid_pager";
import { Pager as PagerComponent } from "./pager";

var Pager = /*#__PURE__*/function (_GridPagerWrapper) {
  _inherits(Pager, _GridPagerWrapper);

  function Pager() {
    _classCallCheck(this, Pager);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pager).apply(this, arguments));
  }

  _createClass(Pager, [{
    key: "getProps",
    value: function getProps() {
      var props = _get(_getPrototypeOf(Pager.prototype), "getProps", this).call(this);

      props.onKeyDown = this._wrapKeyDownHandler(props.onKeyDown);
      return props;
    }
  }, {
    key: "_propsInfo",
    get: function get() {
      return {
        twoWay: [["pageSize", "defaultPageSize", "pageSizeChange"], ["pageIndex", "defaultPageIndex", "pageIndexChange"]],
        allowNull: [],
        elements: [],
        templates: [],
        props: ["defaultPageSize", "pageSizeChange", "defaultPageIndex", "pageIndexChange", "gridCompatibility", "className", "showInfo", "infoText", "lightModeEnabled", "displayMode", "maxPagesCount", "pageCount", "pagesCountText", "visible", "hasKnownLastPage", "pagesNavigatorVisible", "showPageSizes", "pageSizes", "rtlEnabled", "showNavigationButtons", "totalCount", "onKeyDown", "pageSize", "pageIndex"]
      };
    }
  }, {
    key: "_viewComponent",
    get: function get() {
      return PagerComponent;
    }
  }]);

  return Pager;
}(GridPagerWrapper);

export { Pager as default };
registerComponent("dxPager", Pager);